/**
 * CircleFrame mark: M5.T1.
 *
 * Wobbly hand-drawn circular frame, used as an alternative to BoxFrame
 * for round badges (avatar accents, "1st place" callouts).
 */
type CircleFrameProps = {
  size?: number;
  strokeWidth?: number;
};

export function CircleFrame({ size = 80, strokeWidth = 1.5 }: CircleFrameProps) {
  const s = size;
  const c = s / 2;
  const r = c - 4;
  return (
    <svg
      class="mark-circle-frame"
      viewBox={`0 0 ${s} ${s}`}
      width={s}
      height={s}
      aria-hidden="true"
    >
      {/* Two slightly-offset arcs give the doodled wobble */}
      <path
        d={`M ${c - r} ${c} C ${c - r} ${c - r * 1.05} ${c + r * 0.95} ${c - r * 1.02} ${c + r} ${c}`}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d={`M ${c + r} ${c} C ${c + r} ${c + r * 1.05} ${c - r * 0.95} ${c + r * 1.02} ${c - r} ${c}`}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
